import {makeCall, patch, postForm, put} from "./client-lib";

export type ServiceStatus = {
    serviceName: string;
    emergency: boolean;
    clientName: Client;
}

export type ClientStatus = {
    clientName: Client;
    circuitBreakerName: string;
    automaticEmergency: boolean;
}

export enum Client {
    SALESFORCE = "Salesforce",
    MEDIACONNECT = "Mediaconnect",
    SKOLON = "Skolon"
}

export type SpidActive = {
   active: boolean
}

export type ResponseMessage = {
    reason: string,
    reasonDescription: string,
    message: string,
    responseUrl: string
}

export function fetchServiceStatuses(signal: AbortSignal): Promise<ServiceStatus[]>  {
    return makeCall<ServiceStatus[]>('/internal/service-statuses', { signal: signal });
}

export function fetchClientStatuses(signal: AbortSignal): Promise<ClientStatus[]>  {
    return makeCall<ClientStatus[]>('/internal/client-statuses', { signal: signal });
}

export function invokeServiceStatusChange(service: string, emergency: boolean): Promise<ServiceStatus> {
    return patch<ServiceStatus>(`/internal/service-statuses/${service}`,
        {
            emergency: emergency
        });
}

export function invokeCreateService(service: string): Promise<ServiceStatus> {
    return put(`/internal/service-statuses/${service}`);
}

export function fetchSpidActive(): Promise<SpidActive> {
    return makeCall<SpidActive>('/internal/spid');
}

export function fetchPermissions(): Promise<string[]> {
    return makeCall<string[]>('/internal/permissions');
}

export function invokeChangeSpidActive(spidActive: boolean): Promise<void> {
    return put<void>(`/internal/spid`, { active: spidActive });
}

export function invokeLogin(loginFormData: FormData) {
    return postForm<void>('/login', loginFormData, true)
}

export function invokeLogout() {
    return makeCall<void>('/logout', {}, false)
}
export function fetchResponseMessages(): Promise<ResponseMessage[]> {
    return makeCall<ResponseMessage[]>('/internal/response-messages');
}

export function invokeChangeResponseMessage(responseMessage: ResponseMessage): Promise<void> {
    return patch<void>(`/internal/response-messages/${responseMessage.reason}`,
        {
            message: responseMessage.message,
            responseUrl: responseMessage.responseUrl
        });
}




